import { oz } from '@weft/utils';
import { ApiDateSchema } from '../../primitives';

export const BaseSystemEventMessageSchema = oz.object({
  date: ApiDateSchema,
  accountId: oz.string(),
  duplicationId: oz.string().optional(),
});

export type BaseSystemEventMessage = oz.TypeOf<typeof BaseSystemEventMessageSchema>;